import {
  Box,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import ReactPlayer from "react-player";

const PreviewModal = ({
  isOpen,
  onClose,
  url,
  title = "Preview",
  urlType = null,
}) => {
  // Function to detect if URL is an image
  const isImageUrl = (url) => {
    if (!url) return false;

    // Check for common image extensions
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];
    const lowerUrl = url.toLowerCase();

    return (
      imageExtensions.some((ext) => lowerUrl.includes(ext)) ||
      lowerUrl.includes("image") ||
      lowerUrl.includes("img")
    );
  };

  // Function to detect if URL is a video
  const isVideoUrl = (url) => {
    if (!url) return false;

    // Check for common video extensions
    const videoExtensions = [
      ".mp4",
      ".avi",
      ".mov",
      ".wmv",
      ".flv",
      ".webm",
      ".mkv",
    ];
    const lowerUrl = url.toLowerCase();

    return (
      videoExtensions.some((ext) => lowerUrl.includes(ext)) ||
      lowerUrl.includes(".m3u8") ||
      lowerUrl.includes("playlist.m3u8") ||
      lowerUrl.includes("video") ||
      lowerUrl.includes("youtube") ||
      lowerUrl.includes("vimeo") ||
      lowerUrl.includes("dailymotion")
    );
  };

  // Determine content type based on urlType prop or URL detection
  const getContentType = () => {
    if (urlType) {
      return urlType.toLowerCase();
    }

    if (isImageUrl(url)) {
      return "image";
    }

    if (isVideoUrl(url)) {
      return "video";
    }

    // Default to video for unknown types
    return "video";
  };

  const contentType = getContentType();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent maxW="900px">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <div
            style={{
              aspectRatio: "16/9",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {url && contentType === "image" ? (
              <Image
                src={url}
                alt={title}
                maxW="100%"
                maxH="100%"
                objectFit="contain"
                fallback={
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    color="gray.500"
                  >
                    Image not available
                  </Box>
                }
              />
            ) : contentType === "video" ? (
              <ReactPlayer
                url={url}
                controls={true}
                width="100%"
                height="100%"
                playing={true}
                fallback={
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    color="gray.500"
                  >
                    Video not available
                  </Box>
                }
              />
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"
                color="gray.500"
              >
                Content not available
              </Box>
            )}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PreviewModal;
